import { render, staticRenderFns } from "./NoVdt.vue?vue&type=template&id=08e7cc2a&scoped=true&"
import script from "./NoVdt.vue?vue&type=script&lang=js&"
export * from "./NoVdt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7cc2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e7cc2a')) {
      api.createRecord('08e7cc2a', component.options)
    } else {
      api.reload('08e7cc2a', component.options)
    }
    module.hot.accept("./NoVdt.vue?vue&type=template&id=08e7cc2a&scoped=true&", function () {
      api.rerender('08e7cc2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/NoVdt.vue"
export default component.exports